<div class="btn" [ngClass]="{'pointer-events-none opacity-70': disabled}" #trigger (click)="disabled ? $event.stopPropagation() : handleOpenMenu()" [cdkMenuTriggerFor]="menu">
  @if (!customTrigger.innerHTML?.length) {
    <div class="flex flex-col gap-2 w-full relative"
      [ngClass]="{'pointer-events-none opacity-70': disabled,'h-0 absolute invisible':!triggeAarea()}">
      @if (label && !labelPosition()) {
        <div class="flex flex-row justify-between w-full items-center">
          <h5 class="text-xs text-zen-primaryLight truncate capitalize">{{ label }}
             @if (ngControl.control.errors?.required) {
            <i
            class="fa-regular fa-asterisk text-3xs mx-1 transform -translate-y-1"></i>
          }
        </h5>
        @if (reset()) {
          <a class="btn text-app text-xs capitalize" (click)="clear($event)">{{translate('reset')}}</a>
        }
      </div>
    }
    <div #area [ngClass]="ngControl.control?.errors && (ngControl.control?.touched || submitted())?'border-zen-red text-zen-red':'border-zen/25 text-zen'"
      class="btn text-sm w-full rounded  border group min-w-full bg-white px-3 h-10 gap-3 leading-10 cursor-pointer flex flex-row justify-between items-center relative">
      @if (list?.length <= 5 || !iTrigger()?.isOpen()) {
        <div class="flex flex-row justify-start items-center gap-2 w-full whitespace-nowrap truncate">
          @if (labelPosition() == 'before') {
            <h5 class="text-sm text-zen text-start text-opacity-70 truncate capitalize">
              {{label}}
            </h5>
          }
          @if ((!selected || (!selected?.length && multiple)) && placeholder) {
            <span
            class="text-sm text-zen/50">{{translate(placeholder)}}</span>
          } @else {
            @if (!multiple) {
              <h5 class="text-sm text-start text-zen truncate">
                @if (!valueTemplate && !optionTemplate && selected) {
                  <span
                  class="text-sm text-zen truncate">{{selected}}</span>
                }
                <ng-container
                  *ngTemplateOutlet="valueTemplate??optionTemplate; context:{$implicit: getValue(selected)}">
                </ng-container>
              </h5>
            }
            @if (multiple) {
              @if (!valueTemplate && !optionTemplate && !valuesTemplate) {
                @for (item of selected; track item) {
                  <span class="text-sm text-zen">{{item?.name}}</span>
                }
              }
              @if ((valueTemplate || optionTemplate)  && !valuesTemplate) {
                <h5 class="truncate w-full">
                  @for (item of selected; track item; let n = $index) {
                    <span>
                      @if (n != 0) {
                        <span>, </span>
                      }
                      <ng-container
                        *ngTemplateOutlet="valueTemplate??optionTemplate; context:{$implicit: getValue(item)}">
                      </ng-container>
                    </span>
                  }
                </h5>
              }
              @if (valuesTemplate) {
                <div class="flex flex-row">
                  <ng-container
                  *ngTemplateOutlet="valuesTemplate; context:{$implicit: getValues(selected)}"></ng-container>
                </div>
              }
            }
          }
        </div>
        <div class="flex flex-col z-10 items-end justify-center">
          @if (!selected?.length || !nullable()) {
            <i [@child5] class="fa-regular text-xs fa-chevron-up leading-[.5rem]"></i>
            <i [@child5] class="fa-regular text-xs fa-chevron-down leading-[.5rem]"></i>
          }
          @if (selected?.length && nullable() && !disable) {
            <i [@child1] (click)="clear($event)"
            class="fal fa-times text-xxs btn w-3 h-3 text-center rounded-full bg-opacity-20 text-zen leading-3"></i>
          }
        </div>
      }
      @if (list?.length > 5 && iTrigger()?.isOpen()) {
        <input #searchBox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
          name="inputSearch" autocomplete="off" [(ngModel)]="searchValue" (keyup)="searchList(searchValue,list)"
          [placeholder]="translate('Search...')" class="w-full leading-8 bg-transparent text-zen" />
      }
    </div>
    <!-- <i [@fadeUpDown] *ngIf="iTrigger?.isOpen()"
  class="fa-thin text-xl fa-caret-up text-zen-primaryLight text-opacity-40"></i> -->
</div>
}
<div [ngClass]="customTrigger.innerHTML?.length == 0?'hidden':'flex'">
  <div class="flex flex-row items-center justify-between w-full" #customTrigger>
    <ng-content select="[trigger]"></ng-content>
  </div>
</div>


</div>
<!-- <zen-validations [control]="ngControl.control" [label]="label" [placeholder]="placeholder"></zen-validations> -->

<ng-template #menu>
  <div [style.direction]="dir" [@fadeUpDown] [style.width.px]="menuWidth"
    class="inline-flex flex-col items-stretch bg-white text-sm text-zen-primaryLight border border-zen-primaryLight border-opacity-10 mt-px rounded p-1"
    cdkMenu>
    <div (click)="$event.stopPropagation()"
      class="flex flex-col bg-white  rounded z-50 p-1 gap-1 innerListScroll max-h-40">
      @if (multiple && showAll() && tempList.length) {
        <div
          [ngClass]="selected.length == list.length?'bg-opacity-5 hover:bg-opacity-20 bg-'+color()+' text-'+color():'hover:bg-zen hover:bg-opacity-5'"
          class="flex flex-row items-center gap-2 px-4 leading-8 min-w-input rounded btn text-zen   cursor-pointer"
          (click)="selectAll()">
          @if (multiple) {
            <i class="text-xl"
            [ngClass]="selected.length == list.length ?'fa-solid fa-square-check text-'+color() : 'fa-regular fa-square text-zen'"></i>
          }
          <h5 class="text-start w-full"> {{'txt_All813' | translate}} </h5>
        </div>
      }
      @for (option of tempList; track option) {
        <div [id]="option[key()]"
          [ngClass]="selectionIncluded(option[key()])|| option[key()] == selected?'bg-opacity-20 hover:bg-opacity-40 bg-'+color()+' text-'+color(): !max() || (selected?.length < max() && multiple)?'hover:bg-zen hover:bg-opacity-5':'pointer-events-none opacity-60'"
          class="flex flex-row items-center gap-2 px-4 leading-8 min-w-input rounded btn text-zen cursor-pointer"
          (click)="handleSelection(option[key()])">
          @if (multiple) {
            <i class="text-xl"
            [ngClass]="selectionIncluded(option[key()])|| option[key()] == selected ?'fa-solid fa-square-check text-'+color() : 'fa-regular fa-square text-zen'"></i>
          }
          @if (!valueTemplate && !optionTemplate) {
            <h5 class="text-start w-full"> {{option }} </h5>
          }
          @if (valueTemplate || optionTemplate) {
            <h5 class="w-full text-start truncate ">
              <ng-container
                *ngTemplateOutlet="optionTemplate?optionTemplate:valueTemplate; context:{$implicit: option}">
              </ng-container>
            </h5>
          }
        </div>
      }



    </div>

    @if (!tempList.length) {
      <div class="w-full flex items-center justify-center p-2">
        {{'txtNoDataAvailable' | translate:language:ModuleNames.Shared}}
      </div>
    }

    <div class="sticky bottom-2 bg-white">
      <ng-content [select]="[create]"></ng-content>
    </div>

  </div>
</ng-template>
<!-- <div *ngIf="invalid && ((!selected && !multiple) || (!selected.length && multiple))"
class="alert alert-danger transform translate-y-1 h-0">
<validation-required [language]="language"></validation-required>
</div> -->